module.exports = __webpack_public_path__ + "static/media/Flagelo v10.02242a6d.glb";